export default __webpack_public_path__ + "static/media/meald.211feaa3.jpg";